import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import SendToCMS from "../components/SendToCMS";
import SendToProblemQueue from "../components/SendToProblemQueue";
import { truncateText, formatDate, apiUrl } from "../util";
import request from "request";
import * as querystring from "querystring";
import Carousel from "../components/Carousel";
import Tests from "../components/Tests";
class ScreenShots extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenshots: null,
      items: null,
      company: "changedotorg",
    };
  }
  componentDidMount() {
    const { id, ctime } = this.props.match.params;
    const { qid } = querystring.parse(window.location.search.replace("?", ""));
    request(
      `${apiUrl}/v1/admin/v2/getScreenShots?id=${id}&ctime=${ctime}`,
      {
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        const json = JSON.parse(data);
        this.setState({
          screenshots: json.screens,
          items: json.items,
          page_types: json.page_types,
          qid,
        });
      }
    );
  }
  render() {
    const { screenshots, items } = this.state;
    const { user } = this.props;
    const { id, ctime } = this.props.match.params;
    const sItems = [];

    if (!user) {
      return (
        <Redirect
          to={{ pathname: "/", state: { from: this.props.location } }}
        />
      );
    }

    if (screenshots) {
      screenshots.fileLocations.forEach((file, i) => {
        const fn = file.split("/").pop();
        if (fn.endsWith(".png") || fn.endsWith(".jpg")) {
          const info = screenshots.comparison[fn];
          sItems.push({
            src: file,
            altText: "",
            caption: `variant ${i + 1},  ${info.count}, ${info.weight}%`,
            weight: `${Number(info.weight).toFixed(0)}%`,
          });
        }
      });
      return (
        <>
          <h1 className="f3">
            <a href={screenshots.url} target="_blank">
              {truncateText(screenshots.url, 80)}
            </a>{" "}
            {formatDate(screenshots.ctime)}{" "}
          </h1>
          <div className="mb2">
            <a
              href={`/screens/${encodeURIComponent(screenshots.url)}`}
              className="ph1"
            >
              Go Back
            </a>
            <SendToCMS id={id} ctime={ctime} qid={this.state.qid} />
            <div className="mt2">
              <SendToProblemQueue
                user={this.props.user}
                url={screenshots.url}
                platform={screenshots.isMobile ? "mobile" : "desktop"}
                sid={screenshots.id}
                qid={this.state.qid}
              />
            </div>
          </div>
          <Carousel images={sItems} isMobile={screenshots.isMobile} />
          {items && items.length !== 0 && (
            <div>
              <h3 className="f3">
                {items.length} {items.length === 1 ? "test" : "tests"} currently
                published
              </h3>
              <Tests items={items} page_types={this.state.page_types} />
            </div>
          )}
        </>
      );
    }

    return <h1>Loading...</h1>;
  }
}

export default ScreenShots;
